import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@ion/env';
import { EMPTY, from, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { AuthenticationService } from './authentication.service';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  private authcService = inject(AuthenticationService);
  private readonly router = inject(Router);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.url.startsWith(environment.apiUrl) || req.url.startsWith('/wiremock')) {
      return from(this.authcService.getToken()).pipe(
        switchMap(token => {
          return next
            .handle(
              token
                ? req.clone({
                    headers: req.headers.set('Authorization', token),
                  })
                : req, // If token is not available, the API should return 401 and thus trigger the error handling
            )
            .pipe(
              catchError((err: unknown) => {
                // handle authc related errors
                if (err instanceof HttpErrorResponse && err.status === 401) {
                  this.authcService.signOut();
                  this.router.navigate(['/sign-in']);
                  return EMPTY;
                }
                return throwError(() => err);
              }),
            );
        }),
      );
    } else {
      return next.handle(req);
    }
  }
}
